import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../pipes/pipes.module";
import { VmManagerLinkComponent } from "./vm-manager-link.component";

@NgModule({
  imports: [CommonModule, RouterModule, PipesModule],
  declarations: [VmManagerLinkComponent],
  exports: [VmManagerLinkComponent]
})
export class VmManagerLinkModule {}
